var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g2, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _g3, _g4, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _g5, _g6, _path152, _g7, _path153, _g8, _path154, _g9, _path155, _g10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 115,
    viewBox: "0 0 122 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2164_1516)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0184 89.5957L59.3089 76.7071C60.6508 75.9359 60.4837 74.59 58.9342 73.6979L39.368 66.2076C37.8185 65.3154 35.474 65.2197 34.1321 65.9909L19.1486 74.7261C17.8067 75.4973 17.9738 76.8432 19.5233 77.7353L31.7775 89.379C33.3321 90.2712 35.6766 90.3669 37.0184 89.5957Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0184 89.5656L59.3089 76.6769C59.9064 76.3342 60.2052 75.8755 60.2153 75.3916C60.2153 75.3765 60.2153 73.7282 60.2153 73.7131C60.2052 73.1284 59.7697 74.1415 58.9342 73.6627L39.368 66.1724C37.8185 65.2803 35.474 65.1845 34.1321 65.9557L19.1486 74.691C18.6979 74.948 18.3738 73.8542 18.2574 74.202C18.2169 74.318 18.2422 75.8503 18.2422 75.9713C18.227 76.5711 18.6625 77.2062 19.5233 77.7002L31.7775 89.3438C33.332 90.241 35.6765 90.3368 37.0184 89.5656Z",
    fill: "url(#paint0_linear_2164_1516)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0184 87.9173L59.3089 75.0286C60.6508 74.2574 60.4837 72.9116 58.9342 72.0194L39.368 64.5291C37.8185 63.637 35.474 63.5412 34.1321 64.3124L19.1486 73.0477C17.8067 73.8189 17.9738 75.1647 19.5233 76.0569L31.7775 87.7005C33.3321 88.5927 35.6766 88.6885 37.0184 87.9173Z",
    fill: "url(#paint1_linear_2164_1516)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M19.1464 73.0528L34.13 64.3175C35.4718 63.5463 37.8163 63.6421 39.3658 64.5343L49.2249 68.3096C49.1337 68.3852 49.0325 68.4558 48.9211 68.5213L26.6306 81.41C26.3217 81.5864 25.9571 81.7175 25.5622 81.8032L19.5262 76.062C17.9767 75.1698 17.8045 73.824 19.1464 73.0528Z",
    fill: "url(#paint2_linear_2164_1516)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M19.5275 75.7797L31.7817 87.4234C33.3312 88.3155 35.6757 88.4113 37.0176 87.6401L59.3081 74.7514C59.8651 74.4339 60.1588 74.0105 60.2043 73.5669C60.2752 74.1113 59.9815 74.6456 59.3081 75.0287L37.0176 87.9173C35.6757 88.6885 33.3312 88.5928 31.7817 87.7006L19.5275 76.0569C18.6211 75.5377 18.1907 74.8573 18.2566 74.2322C18.3224 74.7817 18.7528 75.3361 19.5275 75.7797Z",
    fill: "url(#paint3_radial_2164_1516)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88909 87.993L62.6379 56.4997C65.4382 54.8917 67.7067 50.577 67.7067 46.8621V5.17684C67.7067 1.46196 65.4382 -0.246786 62.6379 1.36115L7.88909 32.8545C5.09392 34.4624 2.82031 38.7821 2.82031 42.497V84.1773C2.82031 87.8922 5.09392 89.6009 7.88909 87.993Z",
    fill: "url(#paint4_linear_2164_1516)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23656 85.0896L61.2157 54.0449C63.4691 52.6184 64.8616 49.7705 64.8616 46.8571V4.90463C64.8616 4.21407 64.1071 3.78563 63.5096 4.13342C63.4387 4.17375 63.383 4.20399 63.3526 4.22415L9.31775 35.3092C6.63398 36.8466 5.67188 39.5836 5.67188 42.497V84.3184C5.67188 85.0594 6.47701 85.5231 7.1201 85.1551C7.17073 85.1249 7.21124 85.1047 7.23656 85.0896Z",
    fill: "url(#paint5_linear_2164_1516)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67188 42.497V84.3184C5.67188 85.0594 6.47701 85.5231 7.1201 85.1551C7.17073 85.1249 7.21124 85.1047 7.23656 85.0896L61.2157 54.0449C63.4691 52.6184 64.8616 49.7705 64.8616 46.8571V4.90463C64.8616 4.21407 64.1071 3.78563 63.5096 4.13342C63.4387 4.17375 63.383 4.20399 63.3526 4.22415L9.31775 35.3092C6.63398 36.8466 5.67188 39.5836 5.67188 42.497ZM6.23901 42.497C6.23901 40.3245 6.82134 37.396 9.60131 35.8032L63.7982 4.62236C63.8489 4.59211 63.9046 4.57699 63.9653 4.57699C64.1223 4.57699 64.2945 4.703 64.2945 4.90463V46.8571C64.2945 49.6344 62.9678 52.2656 60.9322 53.5509L6.83653 84.6662C6.77576 84.7015 6.70487 84.7216 6.63904 84.7216C6.44662 84.7216 6.23901 84.5704 6.23901 84.3234V42.497Z",
    fill: "#BCBEC0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4539 32.0983L61.2028 0.604973C62.3117 -0.0301356 63.3346 -0.151109 64.1701 0.171486C64.2764 0.21181 65.6892 0.957811 65.7905 1.01326C65.7955 1.01326 65.7955 1.0183 65.7955 1.0183C64.9296 0.599932 63.8359 0.680581 62.6408 1.36609L7.88693 32.8544C5.09176 34.4623 2.81816 38.782 2.81816 42.4969V84.1772C2.81816 86.4958 3.70431 88.0332 5.04619 88.4667C4.93479 88.4717 4.79807 88.4314 4.60058 88.3155C4.53476 88.2802 3.00045 87.4183 2.93969 87.3729C1.97758 86.7025 1.375 85.3214 1.375 83.411V41.7358C1.38513 38.0209 3.65367 33.7062 6.4539 32.0983Z",
    fill: "url(#paint6_linear_2164_1516)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M7.6469 32.7335L62.4008 1.24522C63.5503 0.58491 64.6035 0.489139 65.4542 0.857099C64.7301 0.741166 63.8946 0.917585 63.0085 1.42668L8.25455 32.915C5.45938 34.5279 3.18577 38.8426 3.18577 42.5575V84.2378C3.18577 86.4304 3.98077 87.9123 5.20113 88.4416C3.63644 88.1946 2.57812 86.5967 2.57812 84.0563V42.3761C2.57812 38.6612 4.84667 34.3414 7.6469 32.7335Z",
    fill: "url(#paint7_radial_2164_1516)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.567 90.0796L87.1172 80.054C85.1474 78.9249 83.5523 75.8905 83.5523 73.2744V27.0173C83.5523 25.6866 82.4535 25.3943 83.1219 24.9205C83.1472 24.9003 84.6815 24.2098 84.7068 24.1997C85.4208 23.9275 86.1854 23.8065 87.1172 24.3408L104.567 34.3665C106.537 35.4955 108.132 38.53 108.132 41.146V87.398C108.132 88.7842 107.681 89.7772 106.962 90.2258C106.921 90.251 105.073 91.128 105.028 91.1432C104.389 91.3549 105.428 90.5736 104.567 90.0796Z",
    fill: "url(#paint8_linear_2164_1516)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.408 34.4168L86.958 24.3911C86.0262 23.8568 103.44 34.7394 103.44 34.7394C105.41 35.8684 107.005 38.9028 107.005 41.5189C107.005 41.5189 107.967 88.8395 107.967 87.4534V41.1963C107.967 38.5853 106.372 35.5509 104.408 34.4168Z",
    fill: "url(#paint9_radial_2164_1516)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M103.21 90.6945L85.7602 80.6688C83.7904 79.5397 82.1953 76.5053 82.1953 73.8893V27.6373C82.1953 25.0263 83.7904 23.8266 85.7602 24.9557L103.21 34.9813C105.179 36.1104 106.775 39.1448 106.775 41.7609V88.0129C106.77 90.6239 105.174 91.8235 103.21 90.6945Z",
    fill: "url(#paint10_radial_2164_1516)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.897 90.861L85.4477 80.8353C83.4779 79.7062 81.8828 76.6718 81.8828 74.0558V27.8038C81.8828 25.1928 83.4779 23.9931 85.4477 25.1222L102.897 35.1478C104.867 36.2769 106.462 39.3113 106.462 41.9274V88.1794C106.462 90.7904 104.867 91.99 102.897 90.861Z",
    fill: "url(#paint11_linear_2164_1516)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.375 74.3633V28.0558C82.375 25.7674 83.7726 24.7139 85.4993 25.7069L102.853 35.6821C104.579 36.6751 105.977 39.3315 105.977 41.6249V87.9324C105.977 90.2208 104.579 91.2743 102.853 90.2813L85.4993 80.3061C83.7726 79.3131 82.375 76.6517 82.375 74.3633Z",
    fill: "url(#paint12_linear_2164_1516)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0703 74.6454V28.5698C83.0703 26.6544 84.24 25.7723 85.6832 26.604L102.667 36.3675C104.11 37.1992 105.28 39.4221 105.28 41.3425V87.4181C105.28 89.3335 104.11 90.2156 102.667 89.384L85.6832 79.6204C84.24 78.7887 83.0703 76.5608 83.0703 74.6454Z",
    fill: "url(#paint13_linear_2164_1516)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8801 27.1132C84.518 26.3319 83.4141 26.957 83.4141 28.5094V75.1042C83.4141 76.6567 84.518 78.552 85.8801 79.3332L102.474 88.87C103.836 89.6512 104.94 89.0262 104.94 87.4737V40.8789C104.94 39.3265 103.836 37.4312 102.474 36.6499L85.8801 27.1132Z",
    fill: "url(#paint14_linear_2164_1516)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4141 61.7971L104.935 74.1666V50.8894L83.4141 38.5249V61.7971Z",
    fill: "#B086CC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101.147 38.8626L103.299 40.1026C103.38 40.148 103.446 40.1127 103.446 40.0169C103.446 39.9211 103.38 39.8102 103.299 39.7598L101.147 38.5199C101.066 38.4745 101 38.5098 101 38.6055C101 38.7013 101.066 38.8172 101.147 38.8626ZM103.304 40.526L101.152 39.286C101.071 39.2407 101.005 39.2759 101.005 39.3717C101.005 39.4675 101.071 39.5784 101.152 39.6288L103.304 40.8688C103.385 40.9141 103.451 40.8788 103.451 40.7831C103.451 40.6873 103.385 40.5714 103.304 40.526ZM103.304 41.2922L101.152 40.0522C101.071 40.0068 101.005 40.0421 101.005 40.1379C101.005 40.2336 101.071 40.3445 101.152 40.3949L103.304 41.6349C103.385 41.6803 103.451 41.645 103.451 41.5492C103.451 41.4535 103.385 41.3375 103.304 41.2922Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8506 31.6827C87.9906 31.6012 87.9897 31.3403 87.8486 31.1C87.7075 30.8597 87.4795 30.7309 87.3395 30.8124C87.1995 30.8939 87.2004 31.1548 87.3415 31.3951C87.4826 31.6354 87.7106 31.7642 87.8506 31.6827Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8675 30.8331C86.8675 31.06 86.7054 31.1507 86.508 31.0347C86.3105 30.9188 86.1484 30.6466 86.1484 30.4198C86.1484 30.193 86.3105 30.1022 86.508 30.2182C86.7105 30.3291 86.8675 30.6063 86.8675 30.8331Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7894 30.203C85.7894 30.4298 85.6273 30.5206 85.4298 30.4046C85.2324 30.2887 85.0703 30.0165 85.0703 29.7897C85.0703 29.5629 85.2324 29.4721 85.4298 29.5881C85.6273 29.704 85.7894 29.9762 85.7894 30.203Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104.09 67.2864L100.023 64.9476V64.3831L104.09 66.7219V67.2864Z",
    fill: "#9122EB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M102.965 67.6443L100.023 65.9406V65.5776L102.965 67.2864V67.6443Z",
    fill: "#9122EB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M102.965 68.3046L100.023 66.5958V66.2329L102.965 67.9417V68.3046Z",
    fill: "#9122EB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7537 49.3269L93.6875 46.9881V46.4236L97.7537 48.7624V49.3269Z",
    fill: "#9122EB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.79 73.9904L104.578 73.8694L83.3203 61.6511V38.6511L104.79 50.9904V73.9904ZM83.6039 61.4898L104.512 73.5065V51.1567L83.6039 39.1401V61.4898Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6117 40.1179H85.3281V62.6996H85.6117V40.1179Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0336 41.499H87.75V64.0807H88.0336V41.499Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4554 42.8801H90.1719V65.4618H90.4554V42.8801Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8695 44.2664H92.5859V66.848H92.8695V44.2664Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2914 45.6475H95.0078V68.2291H95.2914V45.6475Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7133 47.0286H97.4297V69.6102H97.7133V47.0286Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.135 48.4146H99.8516V70.9962H100.135V48.4146Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.557 49.7957H102.273V72.3773H102.557V49.7957Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5324 41.4311L83.3906 41.6755L104.58 53.8535L104.722 53.609L83.5324 41.4311Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5324 43.9343L83.3906 44.1787L104.58 56.3567L104.722 56.1122L83.5324 43.9343Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5324 46.435L83.3906 46.6794L104.58 58.8574L104.722 58.613L83.5324 46.435Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5324 48.9357L83.3906 49.1802L104.58 61.3581L104.722 61.1137L83.5324 48.9357Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5324 51.4365L83.3906 51.6809L104.58 63.8589L104.722 63.6144L83.5324 51.4365Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5324 53.9396L83.3906 54.1841L104.58 66.362L104.722 66.1176L83.5324 53.9396Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5324 56.4404L83.3906 56.6848L104.58 68.8628L104.722 68.6183L83.5324 56.4404Z",
    fill: "#3C0862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5324 58.9411L83.3906 59.1855L104.58 71.3635L104.722 71.1191L83.5324 58.9411Z",
    fill: "#3C0862"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6295 49.6898L93.6875 47.9811V47.6182L96.6295 49.3269V49.6898Z",
    fill: "#9122EB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6295 50.3452L93.6875 48.6364V48.2786L96.6295 49.9873V50.3452Z",
    fill: "#9122EB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.935 54.0297L99.2939 58.6871L92.868 52.8552L83.4141 59.5843V61.1973L92.8072 54.5085L99.2685 60.3757L104.935 55.6981V54.0297Z",
    fill: "url(#paint15_linear_2164_1516)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M102.474 36.6499L85.8801 27.1132C84.518 26.3319 83.4141 26.957 83.4141 28.5094V75.1042C83.4141 76.6567 84.518 78.552 85.8801 79.3332L102.474 88.87C103.836 89.6512 104.94 89.0262 104.94 87.4737V40.8789C104.94 39.3265 103.836 37.4312 102.474 36.6499ZM104.722 87.4737C104.722 87.9576 104.606 88.3508 104.393 88.623C104.196 88.87 103.912 88.996 103.578 88.996C103.274 88.996 102.93 88.8901 102.58 88.6885L85.9864 79.1518C84.6851 78.4058 83.6267 76.5912 83.6267 75.1042V28.5094C83.6267 27.5719 84.0673 26.9872 84.7711 26.9872C85.075 26.9872 85.4193 27.0931 85.7687 27.2947L102.362 36.8314C103.664 37.5774 104.722 39.392 104.722 40.8789V87.4737Z",
    fill: "#BCBEC0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8983 51.4742C92.792 51.4742 92.7109 51.3885 92.7109 51.2877V50.3602C92.7109 50.2544 92.797 50.1737 92.8983 50.1737C93.0046 50.1737 93.0857 50.2594 93.0857 50.3602V51.2877C93.0857 51.3885 92.9996 51.4742 92.8983 51.4742ZM92.8983 49.6192C92.792 49.6192 92.7109 49.5336 92.7109 49.4327V48.5053C92.7109 48.3994 92.797 48.3188 92.8983 48.3188C93.0046 48.3188 93.0857 48.4045 93.0857 48.5053V49.4327C93.0857 49.5386 92.9996 49.6192 92.8983 49.6192ZM92.8983 47.7643C92.792 47.7643 92.7109 47.6786 92.7109 47.5778V46.6504C92.7109 46.5445 92.797 46.4639 92.8983 46.4639C93.0046 46.4639 93.0857 46.5496 93.0857 46.6504V47.5778C93.0857 47.6837 92.9996 47.7643 92.8983 47.7643Z",
    fill: "#7C1DC9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2967 64.2469C99.1904 64.2469 99.1094 64.1612 99.1094 64.0604V63.1329C99.1094 63.0271 99.1955 62.9464 99.2967 62.9464C99.398 62.9464 99.4841 63.0321 99.4841 63.1329V64.0604C99.4841 64.1612 99.398 64.2469 99.2967 64.2469ZM99.2967 62.392C99.1904 62.392 99.1094 62.3063 99.1094 62.2055V61.278C99.1094 61.1721 99.1955 61.0915 99.2967 61.0915C99.398 61.0915 99.4841 61.1772 99.4841 61.278V62.2055C99.4841 62.3113 99.398 62.392 99.2967 62.392ZM99.2967 60.537C99.1904 60.537 99.1094 60.4513 99.1094 60.3505V59.4231C99.1094 59.3172 99.1955 59.2366 99.2967 59.2366C99.398 59.2366 99.4841 59.3223 99.4841 59.4231V60.3505C99.4841 60.4564 99.398 60.537 99.2967 60.537Z",
    fill: "#7C1DC9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M93.486 46.7664C93.4961 46.3531 93.2074 45.8389 92.8429 45.6171C92.4783 45.3954 92.1744 45.5516 92.1643 45.9599C92.1542 46.3732 92.4428 46.8874 92.8074 47.1091C93.172 47.3309 93.4758 47.1747 93.486 46.7664Z",
    fill: "url(#paint16_radial_2164_1516)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9078 64.8216C99.918 64.4082 99.6293 63.8941 99.2647 63.6723C98.9001 63.4505 98.5963 63.6068 98.5862 64.0151C98.5761 64.4284 98.8647 64.9425 99.2293 65.1643C99.5939 65.3911 99.8977 65.2349 99.9078 64.8216Z",
    fill: "url(#paint17_radial_2164_1516)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9187 40.0976L91.878 40.5512L92.5971 38.2477L90.6172 35.3947L93.1035 36.7658L93.9187 34.553L94.734 37.7033L97.2203 39.1852L95.2404 39.7649L95.9594 42.8951L93.9187 40.0976Z",
    fill: "url(#paint18_linear_2164_1516)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8461 42.7337L97.9903 42.9202L98.2941 41.9574L97.4688 40.7679L98.5017 41.3375L98.8461 40.415L99.1853 41.7306L100.223 42.3506L99.398 42.5926L99.6968 43.8981L98.8461 42.7337Z",
    fill: "url(#paint19_linear_2164_1516)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M102.174 44.5484L101.323 44.7349L101.622 43.7721L100.797 42.5826L101.835 43.1522L102.174 42.2297L102.513 43.5453L103.552 44.1653L102.726 44.4073L103.025 45.7128L102.174 44.5484Z",
    fill: "url(#paint20_linear_2164_1516)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8539 35.3695L85.0032 35.5611L85.3019 34.5983L84.4766 33.4037L85.5146 33.9783L85.8539 33.0559L86.1982 34.3715L87.2312 34.9915L86.4058 35.2284L86.7046 36.5389L85.8539 35.3695Z",
    fill: "url(#paint21_linear_2164_1516)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M89.182 37.1893L88.3313 37.3758L88.6351 36.413L87.8047 35.2234L88.8427 35.793L89.182 34.8706L89.5263 36.1862L90.5644 36.8062L89.734 37.0481L90.0378 38.3536L89.182 37.1893Z",
    fill: "url(#paint22_linear_2164_1516)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2344 39.7648L95.9534 42.895L96.4092 42.5976L95.7256 39.6187L95.2344 39.7648Z",
    fill: "url(#paint23_linear_2164_1516)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1001 36.7658L93.2672 36.3071L91.0747 35.0974L90.6797 35.415L91.2721 35.7577L93.1001 36.7658Z",
    fill: "url(#paint24_linear_2164_1516)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1851 37.406L94.3698 34.2556L93.9141 34.553L94.7293 37.7033L97.2156 39.1853L97.6713 38.8879L95.1851 37.406Z",
    fill: "url(#paint25_linear_2164_1516)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2344 39.7648L95.9534 42.895L95.3812 39.7195L95.2344 39.7648Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1001 36.7657L93.1508 36.6245L90.6797 35.4148L91.2721 35.7576L93.1001 36.7657Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M94.866 37.6277L93.9141 34.553L94.7293 37.7033L97.2156 39.1852L94.866 37.6277Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8705 76.1831L95.7109 75.4976V82.9172L96.8705 83.6028V76.1831Z",
    fill: "url(#paint26_linear_2164_1516)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M99.019 75.6386L97.8594 74.948V84.1268L99.019 84.8174V75.6386Z",
    fill: "url(#paint27_linear_2164_1516)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M101.222 76.3493L100.062 75.6638V85.387L101.222 86.0725V76.3493Z",
    fill: "url(#paint28_linear_2164_1516)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2969 74.3181V80.3315L92.4565 81.017V75.0036L91.2969 74.3181Z",
    fill: "url(#paint29_linear_2164_1516)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6596 77.0097L93.5 76.3242V81.5865L94.6596 82.2721V77.0097Z",
    fill: "url(#paint30_linear_2164_1516)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M103.386 79.3837L102.227 78.6931V86.6421L103.386 87.3276V79.3837Z",
    fill: "url(#paint31_linear_2164_1516)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2455 72.5639L89.0859 71.8733V79.0057L90.2455 79.6912V72.5639Z",
    fill: "url(#paint32_linear_2164_1516)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6719 73.3352V76.42L85.8315 77.1055V74.0258L84.6719 73.3352Z",
    fill: "url(#paint33_linear_2164_1516)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0424 70.7291L86.8828 70.0386V77.675L88.0424 78.3605V70.7291Z",
    fill: "url(#paint34_linear_2164_1516)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8705 77.9472L95.7109 77.2617V82.9172L96.8705 83.6027V77.9472Z",
    fill: "url(#paint35_linear_2164_1516)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M99.019 79.2627L97.8594 78.5771V84.1268L99.019 84.8173V79.2627Z",
    fill: "url(#paint36_linear_2164_1516)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M101.222 79.1921L100.062 78.5066V85.3869L101.222 86.0724V79.1921Z",
    fill: "url(#paint37_linear_2164_1516)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2969 76.2585V80.3313L92.4565 81.0168V76.9441L91.2969 76.2585Z",
    fill: "url(#paint38_linear_2164_1516)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6596 78.9603L93.5 78.2698V81.5865L94.6596 82.272V78.9603Z",
    fill: "url(#paint39_linear_2164_1516)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2455 73.1184L89.0859 72.4329V79.0057L90.2455 79.6912V73.1184Z",
    fill: "url(#paint40_linear_2164_1516)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6719 74.6155V76.42L85.8315 77.1055V75.306L84.6719 74.6155Z",
    fill: "url(#paint41_linear_2164_1516)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0424 74.454L86.8828 73.7634V77.6749L88.0424 78.3604V74.454Z",
    fill: "url(#paint42_linear_2164_1516)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M103.386 83.26L102.227 82.5745V86.6422L103.386 87.3277V83.26Z",
    fill: "url(#paint43_linear_2164_1516)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M111.53 45.7733L109.281 47.0939L119.753 43.8226L122.001 42.502L111.53 45.7733Z",
    fill: "url(#paint44_linear_2164_1516)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M115.461 53.3492L117.704 52.0235L121.998 42.502L119.75 43.8226L115.461 53.3492Z",
    fill: "url(#paint45_linear_2164_1516)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M106.844 57.0943L108.003 56.6155L115.867 50.1484L113.619 51.4741L106.844 57.0943Z",
    fill: "url(#paint46_linear_2164_1516)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M106.844 57.0943L113.619 51.4741L115.462 53.3491L119.751 43.8225L109.279 47.0938L111.183 48.9941L106.854 52.5931L106.844 57.0943Z",
    fill: "url(#paint47_linear_2164_1516)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M106.893 52.8049L111.222 49.2009L111.076 49.0547L106.893 52.5327L106.883 57.0288H106.888L106.893 52.8049Z",
    fill: "url(#paint48_radial_2164_1516)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M119.65 44.0798L119.792 43.7622L109.32 47.0335L109.528 47.2402L119.65 44.0798Z",
    fill: "url(#paint49_radial_2164_1516)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M63.8859 21.7802V17.7427L6.36719 50.3752V54.3723L63.8859 21.7802Z",
    fill: "url(#paint50_linear_2164_1516)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M63.8859 46.9728V42.9353L6.36719 75.5678V79.5649L63.8859 46.9728Z",
    fill: "url(#paint51_linear_2164_1516)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8456 9.15254L6.1875 41.8049L6.36528 42.116L64.0233 9.46361L63.8456 9.15254Z",
    fill: "#25054D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8456 13.361L6.1875 46.0134L6.36529 46.3245L64.0233 13.6721L63.8456 13.361Z",
    fill: "#25054D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8456 17.5649L6.1875 50.2173L6.36528 50.5284L64.0233 17.876L63.8456 17.5649Z",
    fill: "#25054D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8456 21.769L6.1875 54.4214L6.36528 54.7325L64.0233 22.0801L63.8456 21.769Z",
    fill: "#25054D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8456 25.9772L6.1875 58.6296L6.36528 58.9407L64.0233 26.2883L63.8456 25.9772Z",
    fill: "#25054D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8456 30.1813L6.1875 62.8337L6.36528 63.1448L64.0233 30.4924L63.8456 30.1813Z",
    fill: "#25054D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8456 34.3855L6.1875 67.0378L6.36528 67.3489L64.0233 34.6965L63.8456 34.3855Z",
    fill: "#25054D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8456 38.5939L6.1875 71.2463L6.36528 71.5574L64.0233 38.905L63.8456 38.5939Z",
    fill: "#25054D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8456 42.7976L6.1875 75.45L6.36528 75.761L64.0233 43.1086L63.8456 42.7976Z",
    fill: "#25054D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8456 47.0019L6.1875 79.6543L6.36529 79.9654L64.0233 47.313L63.8456 47.0019Z",
    fill: "#25054D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M57.758 8.55396H57.3984V55.1739H57.758V8.55396Z",
    fill: "#25054D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7736 13.6802H48.4141V60.3002H48.7736V13.6802Z",
    fill: "#25054D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M39.797 18.8064H39.4375V65.4264H39.797V18.8064Z",
    fill: "#25054D"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8205 23.9326H30.4609V70.5526H30.8205V23.9326Z",
    fill: "#25054D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8595 29.0134H21.5V75.6334H21.8595V29.0134Z",
    fill: "#25054D"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M12.883 34.1396H12.5234V80.7596H12.883V34.1396Z",
    fill: "#25054D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M52.5909 13.7758V12.9038L49.3906 14.8041V15.666L52.5909 13.7758Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.3506 16.5533V15.6863L49.3906 19.0634V19.9254L55.3506 16.5533Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54.0999 21.498V20.626L49.3906 23.3227V24.1846L54.0999 21.498Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M55.3506 25.0768V24.2048L49.3906 27.582V28.449L55.3506 25.0768Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54.0999 30.0165V29.1445L49.3906 31.8412V32.7082L54.0999 30.0165Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M52.5909 35.0771V34.2051L49.3906 36.1054V36.9673L52.5909 35.0771Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54.0999 38.54V37.668L49.3906 40.3647V41.2266L54.0999 38.54Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.2188 43.2731V42.4011L49.3906 44.624V45.491L53.2188 43.2731Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.3506 46.3781V45.5061L49.3906 48.8833V49.7502L55.3506 46.3781Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M54.0999 51.3229V50.4509L49.3906 53.1476V54.0096L54.0999 51.3229Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.2188 56.0558V55.1838L49.3906 57.4067V58.2686L53.2188 56.0558Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M61.8147 8.59418V7.72217L58.6094 9.62245V10.4844L61.8147 8.59418Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M61.3134 13.166V12.2939L58.6094 13.8817V14.7436L61.3134 13.166Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.3186 16.3163V15.4443L58.6094 18.141V19.003L63.3186 16.3163Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M61.3134 21.6845V20.8125L58.6094 22.4003V23.2672L61.3134 21.6845Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.3186 24.8349V23.9629L58.6094 26.6596V27.5266L63.3186 24.8349Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M61.8147 29.8955V29.0234L58.6094 30.9237V31.7857L61.8147 29.8955Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.3186 33.3583V32.4863L58.6094 35.183V36.045L63.3186 33.3583Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.4426 38.0915V37.2195L58.6094 39.4424V40.3093L62.4426 38.0915Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M61.3134 42.9858V42.1138L58.6094 43.7015V44.5685L61.3134 42.9858Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M63.3186 46.1363V45.2693L58.6094 47.966V48.8279L63.3186 46.1363Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.4426 50.8742V50.0022L58.6094 52.2251V53.087L62.4426 50.8742Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.6585 32.3806V31.5085L31.4531 33.4088V34.2708L34.6585 32.3806Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.4182 35.1628V34.2908L31.4531 37.6679V38.5299L37.4182 35.1628Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.1624 40.1027V39.2307L31.4531 41.9274V42.7893L36.1624 40.1027Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.4182 43.6813V42.8093L31.4531 46.1865V47.0535L37.4182 43.6813Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.1624 48.6211V47.7542L31.4531 50.4508V51.3128L36.1624 48.6211Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.6585 53.6818V52.8098L31.4531 54.7101V55.572L34.6585 53.6818Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.1624 57.1447V56.2727L31.4531 58.9694V59.8313L36.1624 57.1447Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M35.2864 61.8779V61.0059L31.4531 63.2287V64.0957L35.2864 61.8779Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.4182 64.9829V64.1108L31.4531 67.488V68.355L37.4182 64.9829Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.63 18.7709V17.8989L40.4297 19.7942V20.6611L43.63 18.7709Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.3897 21.5483V20.6763L40.4297 24.0585V24.9204L46.3897 21.5483Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.1339 26.4931V25.6211L40.4297 28.3178V29.1797L45.1339 26.4931Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M46.3897 30.072V29.2L40.4297 32.5771V33.4441L46.3897 30.072Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.1339 35.0117V34.1396L40.4297 36.8363V37.7033L45.1339 35.0117Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.63 40.0725V39.2004L40.4297 41.1007V41.9627L43.63 40.0725Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.1339 43.5353V42.6633L40.4297 45.36V46.222L45.1339 43.5353Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.2579 48.2683V47.3962L40.4297 49.6191V50.4811L44.2579 48.2683Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.3897 51.3732V50.5012L40.4297 53.8784V54.7454L46.3897 51.3732Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M45.1339 56.3129V55.4409L40.4297 58.1376V59.0046L45.1339 56.3129Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.2579 61.0512V60.1792L40.4297 62.4021V63.264L44.2579 61.0512Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.7522 33.1315V32.2595L22.5469 34.1548V35.0217L25.7522 33.1315Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.5119 35.9089V35.0369L22.5469 38.414V39.281L28.5119 35.9089Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.2561 40.8537V39.9817L22.5469 42.6784V43.5403L27.2561 40.8537Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.5119 44.4326V43.5605L22.5469 46.9377V47.7996L28.5119 44.4326Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.2561 49.3723V48.5002L22.5469 51.1969V52.0639L27.2561 49.3723Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.7522 54.4328V53.5608L22.5469 55.456V56.323L25.7522 54.4328Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.2561 57.8957V57.0237L22.5469 59.7204V60.5823L27.2561 57.8957Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.3801 62.6289V61.7568L22.5469 63.9797V64.8417L26.3801 62.6289Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M28.5119 65.7338V64.8618L22.5469 68.239V69.1009L28.5119 65.7338Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.2561 70.6735V69.8015L22.5469 72.4982V73.3652L27.2561 70.6735Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.135 37.8747V37.0027L6.92969 38.903V39.7649L10.135 37.8747Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.8947 40.6521V39.7852L6.92969 43.1623V44.0243L12.8947 40.6521Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.6389 45.5969V44.7249L6.92969 47.4215V48.2835L11.6389 45.5969Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M12.8947 49.1755V48.3035L6.92969 51.6806V52.5476L12.8947 49.1755Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.6389 54.1153V53.2483L6.92969 55.945V56.8069L11.6389 54.1153Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.135 59.176V58.304L6.92969 60.2042V61.0662L10.135 59.176Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.6389 62.6389V61.7668L6.92969 64.4635V65.3255L11.6389 62.6389Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.7629 67.372V66.5L6.92969 68.7229V69.5899L10.7629 67.372Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.63371 72.2866V71.4146L6.92969 72.9822V73.8491L9.63371 72.2866Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M11.6389 75.4218V74.5498L6.92969 77.2465V78.1084L11.6389 75.4218Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.7629 80.1547V79.2827L6.92969 81.5056V82.3675L10.7629 80.1547Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.7835 34.069V33.197L13.5781 35.0923V35.9542L16.7835 34.069Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.5432 36.8464V35.9744L13.5781 39.3515V40.2185L19.5432 36.8464Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.2874 41.7861V40.9141L13.5781 43.6108V44.4777L18.2874 41.7861Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.5432 45.3649V44.4929L13.5781 47.8751V48.7371L19.5432 45.3649Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.2874 50.3098V49.4377L13.5781 52.1344V52.9964L18.2874 50.3098Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.7835 55.3705V54.4985L13.5781 56.3938V57.2608L16.7835 55.3705Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.2874 58.8283V57.9563L13.5781 60.653V61.52L18.2874 58.8283Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.4114 63.5664V62.6943L13.5781 64.9172V65.7792L17.4114 63.5664Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.5432 66.6713V65.7993L13.5781 69.1765V70.0384L19.5432 66.6713Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M18.2874 71.611V70.739L13.5781 73.4357V74.2976L18.2874 71.611Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.4114 76.3442V75.4722L13.5781 77.695V78.562L17.4114 76.3442Z",
    fill: "#EBDEF3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909,
    d: "M19.2235 26.8715C20.7325 26.0045 21.9528 26.7001 21.9528 28.4189V59.6502C21.9528 61.374 20.7325 63.4709 19.2235 64.3379L10.7266 69.0608C9.21761 69.9278 7.44531 69.1465 7.44531 67.4227V36.1965C7.44531 34.4726 9.21761 32.4615 10.7266 31.5945L19.2235 26.8715Z",
    fill: "url(#paint52_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1818,
    d: "M19.3604 26.932C20.8694 26.0651 22.0897 26.7607 22.0897 28.4795V59.6149C22.0897 61.3388 20.8694 63.4357 19.3604 64.3026L10.8584 69.0307C9.34941 69.8976 7.63281 69.1264 7.63281 67.4026V36.2722C7.63281 34.5483 9.34941 32.527 10.8584 31.6601L19.3604 26.932Z",
    fill: "url(#paint53_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M19.5129 26.9923C21.0218 26.1254 22.2422 26.821 22.2422 28.5398V59.5845C22.2422 61.3084 21.0218 63.4052 19.5129 64.2722L11.0058 69.0053C9.49683 69.8722 7.83594 69.1111 7.83594 67.3873V36.3476C7.83594 34.6237 9.49683 32.5924 11.0058 31.7305L19.5129 26.9923Z",
    fill: "url(#paint54_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M19.6575 27.053C21.1665 26.186 22.3869 26.8816 22.3869 28.6055V59.5544C22.3869 61.2783 21.1665 63.3752 19.6575 64.2421L11.1454 68.9803C9.63645 69.8472 8.03125 69.0911 8.03125 67.3673V36.4183C8.03125 34.6945 9.63645 32.6581 11.1454 31.7911L19.6575 27.053Z",
    fill: "url(#paint55_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M19.7944 27.1184C21.3034 26.2515 22.5237 26.9471 22.5237 28.6709V59.5241C22.5237 61.248 21.2983 63.3448 19.7944 64.2118L11.2823 68.9499C9.77331 69.8169 8.21875 69.0709 8.21875 67.347V36.4939C8.21875 34.77 9.77331 32.7235 11.2823 31.8566L19.7944 27.1184Z",
    fill: "url(#paint56_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5455,
    d: "M19.9469 27.179C21.4559 26.312 22.6813 27.0076 22.6813 28.7315V59.4939C22.6813 61.2178 21.4559 63.3197 19.9469 64.1867L11.4297 68.9298C9.92073 69.7968 8.42188 69.0609 8.42188 67.337V36.5695C8.42188 34.8457 9.92073 32.7891 11.4297 31.9221L19.9469 27.179Z",
    fill: "url(#paint57_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M20.0837 27.2393C21.5927 26.3723 22.8181 27.0679 22.8181 28.7918V59.4584C22.8181 61.1823 21.5927 63.2842 20.0837 64.1512L11.5615 68.8943C10.0525 69.7613 8.60938 69.0304 8.60938 67.3116V36.6399C8.60938 34.916 10.0525 32.8494 11.5615 31.9824L20.0837 27.2393Z",
    fill: "url(#paint58_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7273,
    d: "M20.2362 27.2998C21.7452 26.4329 22.9706 27.1285 22.9706 28.8523V59.4283C22.9706 61.1521 21.7452 63.254 20.2362 64.121L11.7089 68.8692C10.2 69.7362 8.8125 69.0154 8.8125 67.2915V36.7156C8.8125 34.9917 10.2 32.915 11.7089 32.048L20.2362 27.2998Z",
    fill: "url(#paint59_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M20.3758 27.3655C21.8848 26.4985 23.1102 27.1941 23.1102 28.918V59.3982C23.1102 61.122 21.8848 63.2239 20.3758 64.0909L11.8486 68.8441C10.3396 69.7111 9.00781 69.0004 9.00781 67.2765V36.7913C9.00781 35.0675 10.3396 32.9857 11.8486 32.1187L20.3758 27.3655Z",
    fill: "url(#paint60_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9091,
    d: "M20.5256 27.4258C22.0346 26.5588 23.26 27.2544 23.26 28.9783V59.3627C23.26 61.0866 22.0346 63.1885 20.5256 64.0554L11.9932 68.8087C10.4842 69.6756 9.20312 68.975 9.20312 67.2511V36.8668C9.20312 35.1429 10.4842 33.0511 11.9932 32.1841L20.5256 27.4258Z",
    fill: "url(#paint61_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6703 27.4864C22.1792 26.6194 23.4047 27.315 23.4047 29.0388V59.3325C23.4047 61.0564 22.1792 63.1583 20.6703 64.0253L12.1328 68.7835C10.6239 69.6505 9.39844 68.9549 9.39844 67.2311V36.9374C9.39844 35.2135 10.6239 33.1116 12.1328 32.2446L20.6703 27.4864Z",
    fill: "url(#paint62_linear_2164_1516)"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22656 70.5024L46.141 49.3573V11.4978L9.22656 32.6429V70.5024Z",
    fill: "#F9FAFA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 70.5982L46.2895 49.4582V11.5986L9.375 32.7387V70.5982Z",
    fill: "url(#paint63_linear_2164_1516)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67188 70.699L46.5863 49.5539V11.6995L9.67188 32.8395V70.699Z",
    fill: "#F9FAFA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82031 70.7947L46.7398 49.6547V11.7952L9.82031 32.9402V70.7947Z",
    fill: "url(#paint64_linear_2164_1516)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0818 49.2766V15.7822L10.4688 36.1763V69.6707L46.0818 49.2766Z",
    fill: "#F9FAFA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.0818 21.8057V15.7822L10.4688 36.1763V42.1644L46.0818 21.8057Z",
    fill: "#B4B8E3"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0263 43.9891V38.0815L10.4688 41.9829V47.8552L17.0263 43.9891Z",
    fill: "#EBDEF3"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M23.8078 44.9871V40.8035L17.625 44.2966V48.6314L23.8078 44.9871Z",
    fill: "url(#paint65_linear_2164_1516)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M23.8078 50.5116V46.333L17.625 49.8261V54.161L23.8078 50.5116Z",
    fill: "url(#paint66_linear_2164_1516)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M38.5734 47.7039V43.5203L32.3906 47.0134V51.3482L38.5734 47.7039Z",
    fill: "url(#paint67_linear_2164_1516)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M38.5734 31.035V26.8513L32.3906 30.3444V34.6793L38.5734 31.035Z",
    fill: "url(#paint68_linear_2164_1516)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M45.8234 43.6766V39.4929L39.6406 42.986V47.3209L45.8234 43.6766Z",
    fill: "url(#paint69_linear_2164_1516)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0816 49.5236V44.1201L31.7969 52.311V57.6792L46.0816 49.5236Z",
    fill: "#EBDEF3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M10.139 42.4214L46.5572 21.7754L46.4104 21.5183L9.99219 42.1644L10.139 42.4214Z",
    fill: "url(#paint70_linear_2164_1516)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M10.139 48.0264L46.5572 27.3854L46.4104 27.1233L9.99219 47.7694L10.139 48.0264Z",
    fill: "url(#paint71_linear_2164_1516)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M10.139 53.6317L46.5572 32.9907L46.4104 32.7336L9.99219 53.3747L10.139 53.6317Z",
    fill: "url(#paint72_linear_2164_1516)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M10.139 59.2367L46.5572 38.5957L46.4104 38.3386L9.99219 58.9797L10.139 59.2367Z",
    fill: "url(#paint73_linear_2164_1516)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M10.139 64.8417L46.5572 44.2007L46.4104 43.9436L9.99219 64.5846L10.139 64.8417Z",
    fill: "url(#paint74_linear_2164_1516)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3691 19.5627H39.0703V53.7326H39.3691V19.5627Z",
    fill: "url(#paint75_linear_2164_1516)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9628 23.7866H31.6641V57.9565H31.9628V23.7866Z",
    fill: "url(#paint76_linear_2164_1516)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5644 28.0156H24.2656V62.1855H24.5644V28.0156Z",
    fill: "url(#paint77_linear_2164_1516)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1581 32.2397H16.8594V66.4096H17.1581V32.2397Z",
    fill: "url(#paint78_linear_2164_1516)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5391 31.3169L14.6353 31.4933V31.3169H14.5391Z",
    fill: "#931D96"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0112 31.3169L11.8516 31.9218V31.9772L13.1074 34.3563H13.477L14.6366 33.7464V31.4933L14.5404 31.3169H13.0112Z",
    fill: "#941E97"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1074 34.3564L11.8516 31.9773V34.3564H13.1074Z",
    fill: "#951F97"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M19.102 27.8088L18.8438 27.95L20.2008 30.5207L20.7274 30.2434V27.8088H19.102Z",
    fill: "#911C95"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8416 27.95L17.9453 28.4187V30.8483H19.5657L20.1987 30.5206L18.8416 27.95Z",
    fill: "#921D96"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0234 24.3057L26.8083 25.7876V24.3057H26.0234Z",
    fill: "#8E1A94"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1858 24.3057L24.0312 24.9105V26.2765L24.5933 27.3451H25.6516L26.8112 26.7402V25.7876L26.0264 24.3057H25.1858Z",
    fill: "#8F1B95"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5933 27.3452L24.0312 26.2766V27.3452H24.5933Z",
    fill: "#901B95"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2688 20.8025L30.4688 21.2209L31.8258 23.7915L32.8943 23.232V20.8025H31.2688Z",
    fill: "#8C1993"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4716 21.2209L30.1172 21.4074V23.842H31.7376L31.8287 23.7916L30.4716 21.2209Z",
    fill: "#8D1994"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5078 17.2942L38.8345 19.8044L38.9814 19.7288V17.2942H37.5078Z",
    fill: "#8A1792"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3577 17.2942L36.2031 17.9041V20.3336H37.8235L38.8363 19.8044L37.5096 17.2942H37.3577Z",
    fill: "#8A1793"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7734 13.791L45.0722 14.3606V13.791H44.7734Z",
    fill: "#881591"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4436 13.791L42.2891 14.3959V14.8445L43.3373 16.8305H43.9094L45.069 16.2256V14.3606L44.7703 13.791H43.4436Z",
    fill: "#881692"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3373 16.8305L42.2891 14.8445V16.8305H43.3373Z",
    fill: "#891692"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64787 26.2111C9.31628 25.823 10.167 25.8885 11.0481 26.3875C12.6836 27.32 13.9698 29.5076 13.9749 31.3726C13.98 32.1942 13.7318 32.8596 13.2609 33.288C12.947 33.5753 12.552 33.7366 12.1114 33.7568L11.8937 32.7235C12.1671 32.7487 12.39 32.6781 12.5621 32.5269C12.8052 32.3051 12.9419 31.8968 12.9368 31.3777C12.9318 29.8957 11.8279 28.0207 10.5316 27.2797C9.99482 26.9722 9.49857 26.9067 9.16943 27.0982C8.84535 27.2847 8.658 27.7384 8.66306 28.3432C8.66306 29.0237 8.89599 29.81 9.31628 30.5611L8.40988 31.0651C7.90857 30.1679 7.63006 29.2052 7.625 28.3483C7.625 27.3553 7.98452 26.5942 8.64787 26.2111Z",
    fill: "url(#paint79_linear_2164_1516)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7338 22.7079C15.4022 22.3198 16.2529 22.3853 17.134 22.8843C18.7696 23.8168 20.0558 26.0044 20.0608 27.8694C20.0659 28.691 19.8178 29.3564 19.3468 29.7848C19.0329 30.0722 18.6379 30.2335 18.1974 30.2536L17.9796 29.2203C18.2531 29.2455 18.4759 29.1749 18.6481 29.0237C18.8911 28.8019 19.0278 28.3937 19.0228 27.8745C19.0177 26.3926 17.9138 24.5175 16.6175 23.7765C16.0808 23.469 15.5845 23.4035 15.2554 23.5951C14.9313 23.7816 14.7439 24.2352 14.749 24.8401C14.749 25.5205 14.9819 26.3069 15.4022 27.0579L14.4958 27.562C13.9945 26.6647 13.716 25.702 13.7109 24.8451C13.7109 23.8521 14.0705 23.091 14.7338 22.7079Z",
    fill: "url(#paint80_linear_2164_1516)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8197 19.2047C21.4882 18.8166 22.3389 18.8822 23.2199 19.3812C24.8555 20.3137 26.1417 22.5013 26.1468 24.3663C26.1518 25.1879 25.9037 25.8532 25.4328 26.2817C25.1188 26.569 24.7239 26.7303 24.2833 26.7504L24.0656 25.7171C24.339 25.7423 24.5618 25.6718 24.734 25.5205C24.9771 25.2988 25.1138 24.8905 25.1087 24.3713C25.1036 22.8894 23.9998 21.0143 22.7034 20.2733C22.1667 19.9659 21.6704 19.9003 21.3413 20.0919C21.0172 20.2784 20.8299 20.732 20.8349 21.3369C20.8349 22.0174 21.0679 22.8037 21.4882 23.5547L20.5817 24.0588C20.0804 23.1616 19.8019 22.1988 19.7969 21.3419C19.7969 20.349 20.1564 19.5878 20.8197 19.2047Z",
    fill: "url(#paint81_linear_2164_1516)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9057 15.6964C27.5741 15.3083 28.4248 15.3739 29.3059 15.8729C30.9415 16.8054 32.2276 18.993 32.2327 20.858C32.2378 21.6796 31.9896 22.3449 31.5187 22.7734C31.2048 23.0607 30.8098 23.222 30.3693 23.2421L30.1515 22.2088C30.425 22.234 30.6478 22.1635 30.8199 22.0122C31.063 21.7905 31.1997 21.3822 31.1946 20.863C31.1896 19.3811 30.0857 17.506 28.7894 16.765C28.2526 16.4576 27.7564 16.392 27.4272 16.5836C27.1032 16.7701 26.9158 17.2237 26.9209 17.8286C26.9209 18.5091 27.1538 19.2954 27.5741 20.0464L26.6677 20.5505C26.1664 19.6533 25.8879 18.6905 25.8828 17.8336C25.8828 16.8407 26.2474 16.0795 26.9057 15.6964Z",
    fill: "url(#paint82_linear_2164_1516)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9916 12.1933C33.66 11.8052 34.5107 11.8707 35.3918 12.3697C37.0274 13.3022 38.3136 15.4898 38.3186 17.3548C38.3237 18.1764 38.0756 18.8417 37.6047 19.2702C37.2907 19.5575 36.8957 19.7188 36.4552 19.739L36.2375 18.7057C36.5109 18.7309 36.7337 18.6603 36.9059 18.5091C37.1489 18.2873 37.2856 17.879 37.2806 17.3598C37.2755 15.8779 36.1716 14.0028 34.8753 13.2619C34.3386 12.9544 33.8423 12.8889 33.5132 13.0804C33.1891 13.2669 33.0017 13.7206 33.0068 14.3254C33.0068 15.0059 33.2397 15.7922 33.66 16.5433L32.7536 17.0473C32.2523 16.1501 31.9738 15.1874 31.9688 14.3305C31.9688 13.3375 32.3333 12.5764 32.9916 12.1933Z",
    fill: "url(#paint83_linear_2164_1516)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0776 8.6901C39.746 8.30198 40.5967 8.3675 41.4778 8.86652C43.1133 9.79902 44.3995 11.9866 44.4046 13.8516C44.4096 14.6732 44.1615 15.3386 43.6906 15.767C43.3766 16.0543 42.9817 16.2156 42.5411 16.2358L42.3234 15.2025C42.5968 15.2277 42.8196 15.1571 42.9918 15.0059C43.2349 14.7841 43.3716 14.3758 43.3665 13.8567C43.3615 12.3747 42.2576 10.4997 40.9613 9.75869C40.4245 9.45122 39.9283 9.38569 39.5991 9.57723C39.275 9.76374 39.0877 10.2174 39.0927 10.8222C39.0927 11.5027 39.3257 12.289 39.746 13.0401L38.8396 13.5441C38.3383 12.6469 38.0598 11.6791 38.0547 10.8273C38.0547 9.82926 38.4193 9.07318 39.0776 8.6901Z",
    fill: "url(#paint84_linear_2164_1516)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3753 31.5289C13.3703 29.7899 12.1702 27.7485 10.646 26.8815C9.82568 26.4128 9.03068 26.3573 8.41291 26.7152C8.36733 26.7404 8.32176 26.7757 8.28125 26.8059C8.40784 26.6597 8.54963 26.5388 8.71673 26.443C9.33957 26.0801 10.1346 26.1406 10.9498 26.6093C12.474 27.4763 13.669 29.5177 13.6792 31.2567C13.6842 32.0229 13.4513 32.6429 13.0158 33.0411C12.9702 33.0814 12.9196 33.1167 12.869 33.157C13.2032 32.7588 13.3804 32.2043 13.3753 31.5289Z",
    fill: "url(#paint85_radial_2164_1516)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17969 28.706C8.17969 28.1011 8.36198 27.6475 8.68606 27.461C8.70125 27.4509 8.7215 27.4459 8.74176 27.4358C8.58985 27.6727 8.50377 28.0104 8.50377 28.4137C8.50377 29.0941 8.7367 29.8805 9.15698 30.6315L8.78733 30.8331C8.39743 30.1123 8.18475 29.3613 8.17969 28.706Z",
    fill: "url(#paint86_radial_2164_1516)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M19.516 28.0306C19.5109 26.2916 18.3108 24.2502 16.7866 23.3832C15.9663 22.9145 15.1713 22.859 14.5535 23.2169C14.508 23.2421 14.4624 23.2774 14.4219 23.3076C14.5485 23.1615 14.6903 23.0405 14.8574 22.9447C15.4802 22.5818 16.2752 22.6423 17.0905 23.1111C18.6146 23.978 19.8097 26.0194 19.8198 27.7584C19.8249 28.5246 19.5919 29.1446 19.1564 29.5428C19.1109 29.5831 19.0602 29.6184 19.0096 29.6587C19.3438 29.2605 19.521 28.701 19.516 28.0306Z",
    fill: "url(#paint87_radial_2164_1516)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3125 25.2028C14.3125 24.598 14.4948 24.1443 14.8189 23.9578C14.8341 23.9477 14.8543 23.9427 14.8746 23.9326C14.7227 24.1695 14.6366 24.5072 14.6366 24.9105C14.6366 25.591 14.8695 26.3773 15.2898 27.1283L14.9201 27.335C14.5302 26.6142 14.3176 25.8581 14.3125 25.2028Z",
    fill: "url(#paint88_radial_2164_1516)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M25.555 24.5274C25.55 22.7885 24.3499 20.747 22.8257 19.8801C22.0054 19.4113 21.2104 19.3508 20.5926 19.7137C20.547 19.7389 20.5014 19.7742 20.4609 19.8045C20.5875 19.6583 20.7293 19.5373 20.8964 19.4415C21.5193 19.0786 22.3143 19.1391 23.1295 19.6079C24.6537 20.4749 25.8487 22.5163 25.8589 24.2553C25.8639 25.0214 25.631 25.6414 25.1955 26.0396C25.1499 26.0799 25.0993 26.1152 25.0487 26.1555C25.3829 25.7573 25.5601 25.2029 25.555 24.5274Z",
    fill: "url(#paint89_radial_2164_1516)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3516 21.7048C20.3516 21.0999 20.5339 20.6463 20.8579 20.4598C20.8731 20.4497 20.8934 20.4447 20.9136 20.4346C20.7617 20.6715 20.6756 21.0092 20.6756 21.4124C20.6756 22.0929 20.9086 22.8792 21.3289 23.6303L20.9592 23.8319C20.5693 23.1111 20.3566 22.3601 20.3516 21.7048Z",
    fill: "url(#paint90_radial_2164_1516)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6644 20.994C31.6593 19.255 30.4592 17.2136 28.9351 16.3466C28.1147 15.8779 27.3197 15.8224 26.702 16.1803C26.6564 16.2055 26.6108 16.2408 26.5703 16.271C26.6969 16.1248 26.8387 16.0039 27.0058 15.9081C27.6286 15.5452 28.4236 15.6057 29.2389 16.0744C30.7631 16.9414 31.9581 18.9828 31.9682 20.7218C31.9733 21.488 31.7404 22.108 31.3049 22.5062C31.2593 22.5465 31.2087 22.5818 31.158 22.6221C31.4872 22.2239 31.6644 21.6644 31.6644 20.994Z",
    fill: "url(#paint91_radial_2164_1516)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4609 18.1713C26.4609 17.5665 26.6432 17.1128 26.9673 16.9263C26.9825 16.9162 27.0028 16.9112 27.023 16.9011C26.8711 17.138 26.785 17.4757 26.785 17.879C26.785 18.5595 27.0179 19.3458 27.4382 20.0968L27.0686 20.3035C26.6787 19.5777 26.4609 18.8266 26.4609 18.1713Z",
    fill: "url(#paint92_radial_2164_1516)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7972 17.4908C37.7922 15.7518 36.5921 13.7104 35.0679 12.8434C34.2476 12.3747 33.4526 12.3192 32.8348 12.6771C32.7892 12.7023 32.7436 12.7376 32.7031 12.7678C32.8297 12.6217 32.9715 12.5007 33.1386 12.4049C33.7614 12.042 34.5564 12.1025 35.3717 12.5713C36.8959 13.4382 38.0909 15.4797 38.101 17.2186C38.1061 17.9848 37.8732 18.6048 37.4377 19.003C37.3921 19.0433 37.3415 19.0786 37.2908 19.1189C37.62 18.7207 37.7972 18.1663 37.7972 17.4908Z",
    fill: "url(#paint93_radial_2164_1516)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6016 14.6682C32.6016 14.0633 32.7839 13.6097 33.1079 13.4232C33.1231 13.4131 33.1434 13.408 33.1636 13.3979C33.0117 13.6349 32.9256 13.9726 32.9256 14.3758C32.9256 15.0563 33.1586 15.8426 33.5789 16.5937L33.2092 16.7953C32.8193 16.0745 32.6016 15.3234 32.6016 14.6682Z",
    fill: "url(#paint94_radial_2164_1516)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8441 13.9928C43.839 12.2538 42.6389 10.2124 41.1148 9.3454C40.2944 8.87663 39.4994 8.82118 38.8817 9.17906C38.8361 9.20426 38.7905 9.23955 38.75 9.26979C38.8766 9.12362 39.0184 9.00264 39.1855 8.90687C39.8083 8.54395 40.6033 8.60444 41.4186 9.07321C42.9428 9.94018 44.1378 11.9816 44.1479 13.7206C44.153 14.4868 43.92 15.1067 43.4846 15.5049C43.439 15.5453 43.3884 15.5806 43.3377 15.6209C43.6669 15.2227 43.8441 14.6632 43.8441 13.9928Z",
    fill: "url(#paint95_radial_2164_1516)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4116 23.2068C18.4953 22.6624 19.9587 23.111 20.6727 24.2199C21.3866 25.3238 21.0828 26.6646 19.9992 27.209C18.9156 27.7534 17.4521 27.3048 16.7382 26.1958C16.0242 25.092 16.328 23.7562 17.4116 23.2068Z",
    fill: "url(#paint96_radial_2164_1516)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5078 35.8485L13.3281 35.3797L13.6927 38.1571L13.7028 38.152L14.0674 34.9563L14.8878 34.4875V38.6561L14.3459 38.9686V35.8132L14.3358 35.8183L13.9206 39.2156L13.4395 39.4928L13.0243 36.5743L13.0142 36.5794V39.7348L12.5129 40.0221V35.8485H12.5078Z",
    fill: "#8B90B5"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4256 31.9975L19.8281 32.3403V31.7455L21.6004 30.7273V31.3221L21.0029 31.6648V35.2386L20.4307 35.5662V31.9975H20.4256Z",
    fill: "#8B90B5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7812 27.7836L27.3332 27.466L27.5864 30.5256L27.5965 30.5206L27.8699 27.1586L28.4978 26.8007L28.7713 29.8502L28.7814 29.8452L29.0346 26.4932L29.5308 26.2109L29.1612 30.5962L28.4472 31.0045L28.1839 28.3431L28.1738 28.3481L27.9105 31.312L27.1509 31.7505L26.7812 27.7836Z",
    fill: "#8B90B5"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M35.121 23.6906L34.5234 24.0334V23.4386L36.2957 22.4204V23.0152L35.6982 23.358V26.9317L35.126 27.2593V23.6906H35.121Z",
    fill: "#8B90B5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1172 18.9677L43.6363 18.0957V18.6905L42.6945 19.2349V20.3992L43.4338 19.9758V20.5706L42.6945 20.994V22.8137L42.1222 23.1413V18.9677H42.1172Z",
    fill: "#8B90B5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6146 46.3027C36.1159 46.0154 36.5261 46.2473 36.5261 46.8219C36.5261 47.3965 36.1159 48.0972 35.6146 48.3845C35.1133 48.6718 34.7031 48.4399 34.7031 47.8653C34.7082 47.2907 35.1133 46.59 35.6146 46.3027Z",
    fill: "url(#paint97_linear_2164_1516)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M42.763 42.2751C43.2643 41.9878 43.6745 42.2197 43.6745 42.7943C43.6745 43.3689 43.2643 44.0696 42.763 44.3569C42.2617 44.6442 41.8516 44.4123 41.8516 43.8377C41.8566 43.2631 42.2617 42.5624 42.763 42.2751Z",
    fill: "url(#paint98_linear_2164_1516)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6146 29.6335C36.1159 29.3462 36.5261 29.5781 36.5261 30.1527C36.5261 30.7273 36.1159 31.428 35.6146 31.7153C35.1133 32.0026 34.7031 31.7707 34.7031 31.1961C34.7082 30.6215 35.1133 29.9208 35.6146 29.6335Z",
    fill: "url(#paint99_linear_2164_1516)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7943 49.1555C21.2956 48.8682 21.7057 49.1001 21.7057 49.6747C21.7057 50.2493 21.2956 50.9499 20.7943 51.2372C20.293 51.5246 19.8828 51.2927 19.8828 50.7181C19.8828 50.1435 20.293 49.4479 20.7943 49.1555Z",
    fill: "url(#paint100_linear_2164_1516)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7943 43.5405C21.2956 43.2532 21.7057 43.4851 21.7057 44.0597C21.7057 44.6343 21.2956 45.3349 20.7943 45.6223C20.293 45.9096 19.8828 45.6777 19.8828 45.1031C19.8828 44.5285 20.293 43.8278 20.7943 43.5405Z",
    fill: "url(#paint101_linear_2164_1516)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909,
    d: "M26.333 54.3825C26.976 54.0145 27.4976 54.3069 27.4976 55.0428V68.3801C27.4976 69.116 26.976 70.0132 26.333 70.3811L22.7073 72.3974C22.0642 72.7653 21.3047 72.4327 21.3047 71.6967V58.3594C21.3047 57.6235 22.0592 56.7666 22.7073 56.3936L26.333 54.3825Z",
    fill: "url(#paint102_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1818,
    d: "M26.3986 54.4076C27.0417 54.0396 27.5633 54.332 27.5633 55.0679V68.3649C27.5633 69.1008 27.0417 69.998 26.3986 70.366L22.768 72.3872C22.1249 72.7552 21.3906 72.4275 21.3906 71.6916V58.3947C21.3906 57.6588 22.1249 56.7968 22.768 56.4238L26.3986 54.4076Z",
    fill: "url(#paint103_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M26.4593 54.433C27.1023 54.065 27.6239 54.3574 27.6239 55.0933V68.3499C27.6239 69.0859 27.1023 69.9831 26.4593 70.351L22.8286 72.3723C22.1855 72.7403 21.4766 72.4177 21.4766 71.6817V58.4251C21.4766 57.6892 22.1855 56.8222 22.8286 56.4543L26.4593 54.433Z",
    fill: "url(#paint104_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M26.5222 54.4633C27.1653 54.0953 27.6868 54.3877 27.6868 55.1236V68.3399C27.6868 69.0758 27.1653 69.973 26.5222 70.341L22.8864 72.3622C22.2434 72.7302 21.5547 72.4126 21.5547 71.6767V58.4604C21.5547 57.7245 22.2434 56.8525 22.8864 56.4845L26.5222 54.4633Z",
    fill: "url(#paint105_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M26.5828 54.4884C27.2259 54.1205 27.7475 54.4128 27.7475 55.1487V68.3247C27.7475 69.0606 27.2259 69.9578 26.5828 70.3258L22.9471 72.3471C22.304 72.715 21.6406 72.3975 21.6406 71.6615V58.4856C21.6406 57.7496 22.304 56.8776 22.9471 56.5046L26.5828 54.4884Z",
    fill: "url(#paint106_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5455,
    d: "M26.6485 54.5136C27.2916 54.1456 27.8131 54.438 27.8131 55.1739V68.3095C27.8131 69.0455 27.2916 69.9427 26.6485 70.3106L23.0127 72.3369C22.3697 72.7049 21.7266 72.3924 21.7266 71.6565V58.5208C21.7266 57.7849 22.3646 56.9078 23.0127 56.5348L26.6485 54.5136Z",
    fill: "url(#paint107_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M26.7064 54.5387C27.3495 54.1708 27.871 54.4631 27.871 55.199V68.2944C27.871 69.0303 27.3495 69.9275 26.7064 70.2955L23.0656 72.3217C22.4225 72.6897 21.8047 72.3822 21.8047 71.6463V58.551C21.8047 57.8151 22.4225 56.933 23.0656 56.565L26.7064 54.5387Z",
    fill: "url(#paint108_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7273,
    d: "M26.7748 54.569C27.4179 54.201 27.9394 54.4934 27.9394 55.2293V68.2843C27.9394 69.0202 27.4179 69.9174 26.7748 70.2854L23.134 72.3117C22.4909 72.6797 21.8984 72.3722 21.8984 71.6363V58.5813C21.8984 57.8453 22.4909 56.9582 23.134 56.5902L26.7748 54.569Z",
    fill: "url(#paint109_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M26.8327 54.5941C27.4758 54.2262 27.9973 54.5185 27.9973 55.2544V68.2691C27.9973 69.005 27.4758 69.9023 26.8327 70.2753L23.1919 72.3066C22.5488 72.6746 21.9766 72.3721 21.9766 71.6362V58.6215C21.9766 57.8856 22.5437 56.9934 23.1919 56.6255L26.8327 54.5941Z",
    fill: "url(#paint110_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9091,
    d: "M26.8905 54.6195C27.5336 54.2516 28.0552 54.5439 28.0552 55.2798V68.2542C28.0552 68.9901 27.5336 69.8873 26.8905 70.2603L23.2447 72.2917C22.6016 72.6596 22.0547 72.3622 22.0547 71.6263V58.652C22.0547 57.916 22.6016 57.0239 23.2447 56.6509L26.8905 54.6195Z",
    fill: "url(#paint111_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9562 54.6447C27.5993 54.2767 28.1259 54.5691 28.1259 55.305V68.239C28.1259 68.9749 27.6044 69.8721 26.9562 70.2451L23.3103 72.2765C22.6672 72.6495 22.1406 72.3521 22.1406 71.6162V58.6821C22.1406 57.9462 22.6622 57.049 23.3103 56.676L26.9562 54.6447Z",
    fill: "url(#paint112_linear_2164_1516)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909,
    d: "M18.997 67.5888C19.6401 67.2208 20.1617 67.5131 20.1617 68.2491V81.5864C20.1617 82.3223 19.6401 83.2195 18.997 83.5874L15.3714 85.6037C14.7283 85.9716 13.9688 85.639 13.9688 84.903V71.5657C13.9688 70.8298 14.7232 69.9729 15.3714 69.5999L18.997 67.5888Z",
    fill: "url(#paint113_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1818,
    d: "M19.0627 67.6139C19.7058 67.2459 20.2274 67.5383 20.2274 68.2742V81.5712C20.2274 82.3071 19.7058 83.2043 19.0627 83.5723L15.432 85.5935C14.7889 85.9615 14.0547 85.6338 14.0547 84.8979V71.601C14.0547 70.8651 14.7889 70.0031 15.432 69.6301L19.0627 67.6139Z",
    fill: "url(#paint114_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M19.1233 67.6391C19.7664 67.2711 20.288 67.5634 20.288 68.2994V81.556C20.288 82.2919 19.7664 83.1891 19.1233 83.5571L15.4926 85.5783C14.8495 85.9463 14.1406 85.6237 14.1406 84.8878V71.6312C14.1406 70.8952 14.8495 70.0283 15.4926 69.6603L19.1233 67.6391Z",
    fill: "url(#paint115_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M19.1863 67.6644C19.8293 67.2965 20.3509 67.5888 20.3509 68.3248V81.5411C20.3509 82.277 19.8293 83.1742 19.1863 83.5422L15.5505 85.5634C14.9074 85.9314 14.2188 85.6138 14.2188 84.8779V71.6616C14.2188 70.9257 14.9074 70.0537 15.5505 69.6857L19.1863 67.6644Z",
    fill: "url(#paint116_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M19.2469 67.6945C19.89 67.3265 20.4115 67.6189 20.4115 68.3548V81.5308C20.4115 82.2667 19.89 83.1639 19.2469 83.5319L15.6111 85.5531C14.968 85.9211 14.3047 85.6035 14.3047 84.8676V71.6916C14.3047 70.9557 14.968 70.0837 15.6111 69.7107L19.2469 67.6945Z",
    fill: "url(#paint117_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5455,
    d: "M19.3126 67.7199C19.9556 67.3519 20.4772 67.6443 20.4772 68.3802V81.5158C20.4772 82.2517 19.9556 83.149 19.3126 83.5169L15.6768 85.5432C15.0337 85.9112 14.3906 85.5987 14.3906 84.8627V71.7271C14.3906 70.9912 15.0287 70.1141 15.6768 69.7411L19.3126 67.7199Z",
    fill: "url(#paint118_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M19.3704 67.745C20.0135 67.377 20.5351 67.6694 20.5351 68.4053V81.5007C20.5351 82.2366 20.0135 83.1338 19.3704 83.5018L15.7296 85.528C15.0865 85.896 14.4688 85.5885 14.4688 84.8526V71.7573C14.4688 71.0214 15.0865 70.1393 15.7296 69.7713L19.3704 67.745Z",
    fill: "url(#paint119_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7273,
    d: "M19.431 67.7702C20.0741 67.4022 20.5957 67.6945 20.5957 68.4305V81.4855C20.5957 82.2214 20.0741 83.1186 19.431 83.4866L15.7902 85.5129C15.1471 85.8808 14.5547 85.5734 14.5547 84.8374V71.7824C14.5547 71.0465 15.1471 70.1594 15.7902 69.7914L19.431 67.7702Z",
    fill: "url(#paint120_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M19.4967 67.7953C20.1398 67.4273 20.6614 67.7197 20.6614 68.4556V81.4703C20.6614 82.2062 20.1398 83.1034 19.4967 83.4764L15.8559 85.5078C15.2128 85.8757 14.6406 85.5733 14.6406 84.8374V71.8227C14.6406 71.0868 15.2078 70.1946 15.8559 69.8266L19.4967 67.7953Z",
    fill: "url(#paint121_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9091,
    d: "M19.5546 67.8256C20.1977 67.4576 20.7192 67.75 20.7192 68.4859V81.4602C20.7192 82.1962 20.1977 83.0934 19.5546 83.4664L15.9087 85.4977C15.2656 85.8657 14.7188 85.5683 14.7188 84.8324V71.858C14.7188 71.1221 15.2656 70.2299 15.9087 69.8569L19.5546 67.8256Z",
    fill: "url(#paint122_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6203 67.8507C20.2634 67.4828 20.79 67.7751 20.79 68.511V81.4451C20.79 82.181 20.2684 83.0782 19.6203 83.4512L15.9744 85.4825C15.3313 85.8555 14.8047 85.5582 14.8047 84.8222V71.8882C14.8047 71.1523 15.3263 70.2551 15.9744 69.8821L19.6203 67.8507Z",
    fill: "url(#paint123_linear_2164_1516)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2164_1516",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 49,
    width: 19,
    height: 54
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4531 49.2361H35.7027V102.988H17.4531V49.2361Z",
    fill: "url(#paint124_linear_2164_1516)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2164_1516)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2917 54.3069L32.3909 57.2405L27.2917 60.1741L22.1875 57.2405L27.2917 54.3069Z",
    fill: "url(#paint125_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3933 97.5094L27.2891 100.443V60.1741L32.3933 57.2405V97.5094Z",
    fill: "url(#paint126_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2917 100.443L22.1875 97.5094V57.2405L27.2917 60.1741V100.443Z",
    fill: "url(#paint127_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3933 100.206L27.2891 103.14V101.254L32.3933 98.3208V100.206Z",
    fill: "url(#paint128_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2917 103.14L22.1875 100.206V98.3208L27.2917 101.254V103.14Z",
    fill: "url(#paint129_linear_2164_1516)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M22.1875 57.2405L27.2664 59.9624L32.3959 57.2405L27.4487 60.285L27.2917 100.443L27.0487 60.2497L22.1875 57.2405Z",
    fill: "url(#paint130_radial_2164_1516)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2164_1516",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 63,
    width: 19,
    height: 45
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1406 63.395H28.3902V107.041H10.1406V63.395Z",
    fill: "url(#paint131_linear_2164_1516)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2164_1516)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9742 67.5283L25.0733 70.4619L19.9742 73.3955L14.875 70.4619L19.9742 67.5283Z",
    fill: "url(#paint132_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0808 101.562L19.9766 104.496V73.3955L25.0808 70.4619V101.562Z",
    fill: "url(#paint133_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9792 104.496L14.875 101.562V70.4619L19.9792 73.3955V104.496Z",
    fill: "url(#paint134_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.0808 103.891L19.9766 106.824V104.985L25.0808 102.051V103.891Z",
    fill: "url(#paint135_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.9792 106.824L14.875 103.891V102.051L19.9792 104.985V106.824Z",
    fill: "url(#paint136_linear_2164_1516)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 70.4619L19.9488 73.1838L25.0784 70.4619L20.1311 73.5064L19.9792 104.496L19.7362 73.4711L14.875 70.4619Z",
    fill: "url(#paint137_radial_2164_1516)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2164_1516",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 67,
    width: 19,
    height: 44
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65625 67.3267H20.9059V110.968H2.65625V67.3267Z",
    fill: "url(#paint138_linear_2164_1516)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2164_1516)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4898 80.4673L17.5889 83.4059L12.4898 86.3345L7.39062 83.4009L12.4898 80.4673Z",
    fill: "url(#paint139_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5964 105.489L12.4922 108.422V86.3345L17.5964 83.4009V105.489Z",
    fill: "url(#paint140_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4948 108.422L7.39062 105.489V83.4009L12.4948 86.3345V108.422Z",
    fill: "url(#paint141_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.5964 107.787L12.4922 110.716V108.871L17.5964 105.942V107.787Z",
    fill: "url(#paint142_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.4948 110.716L7.39062 107.787V105.942L12.4948 108.871V110.716Z",
    fill: "url(#paint143_linear_2164_1516)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.39062 83.4009L12.4645 86.1228L17.594 83.4009L12.6468 86.4454L12.4948 108.422L12.2518 86.4101L7.39062 83.4009Z",
    fill: "url(#paint144_radial_2164_1516)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2164_1516",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: 71,
    width: 19,
    height: 45
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.73438 71.9136H13.5152V115.56H-4.73438V71.9136Z",
    fill: "url(#paint145_linear_2164_1516)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2164_1516)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.09916 93.8853L10.2034 96.8239L5.09916 99.7575L0 96.8189L5.09916 93.8853Z",
    fill: "url(#paint146_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09916 107.036L10.2034 109.97L5.09916 112.903L0 109.965L5.09916 107.036Z",
    fill: "url(#paint147_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2007 110.081L5.10156 113.014V99.7524L10.2007 96.8188V110.081Z",
    fill: "url(#paint148_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10422 113.014L0 110.081V96.8188L5.10422 99.7524V113.014Z",
    fill: "url(#paint149_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.2007 112.066L5.10156 115V113.362L10.2007 110.428V112.066Z",
    fill: "url(#paint150_linear_2164_1516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.10422 115L0 112.066V110.428L5.10422 113.362V115Z",
    fill: "url(#paint151_linear_2164_1516)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 96.8188L5.0789 99.5407L10.2034 96.8188L5.25613 99.8633L5.10422 113.014L4.86116 99.8281L0 96.8188Z",
    fill: "url(#paint152_radial_2164_1516)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2164_1516",
    x1: 58.536,
    y1: 77.7618,
    x2: 14.2652,
    y2: 77.7618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0556,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2576,
    stopColor: "#210243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3572,
    stopColor: "#25084B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4341,
    stopColor: "#2C1358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4697,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#341D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4954,
    stopColor: "#3C2273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5093,
    stopColor: "#492B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#5B38A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5303,
    stopColor: "#653FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#5F3AAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5617,
    stopColor: "#49298D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#391D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#2F1666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6263,
    stopColor: "#2C1361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    stopColor: "#270C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7491,
    stopColor: "#220346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2164_1516",
    x1: 46.6892,
    y1: 80.5953,
    x2: 26.6645,
    y2: 69.4667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2031,
    stopColor: "#290F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4949,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2164_1516",
    x1: 36.0443,
    y1: 75.3714,
    x2: 32.1313,
    y2: 68.7805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9146 84.3064) rotate(180) scale(15.7506 15.6785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF8AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2164_1516",
    x1: 3.55526,
    y1: 88.3566,
    x2: 70.8956,
    y2: -5.25431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2031,
    stopColor: "#290F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4949,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2164_1516",
    x1: 62.1422,
    y1: 4.33293,
    x2: 4.86835,
    y2: 90.8517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2164_1516",
    x1: -10.8419,
    y1: 90.3834,
    x2: 42.1326,
    y2: 5.34799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0556,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2576,
    stopColor: "#210243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3572,
    stopColor: "#25084B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4341,
    stopColor: "#2C1358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4697,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#351F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4954,
    stopColor: "#422C73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5093,
    stopColor: "#584188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#765FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5303,
    stopColor: "#8770B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#7E67AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5617,
    stopColor: "#5C468D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#442E75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#362066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6263,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    stopColor: "#2A1155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7491,
    stopColor: "#230446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.28951 42.0825) rotate(180) scale(9.07685 9.03533)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF8AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2164_1516",
    x1: 77.7962,
    y1: 26.09,
    x2: 100.43,
    y2: 65.4739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0556,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2576,
    stopColor: "#210243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3572,
    stopColor: "#25084B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4341,
    stopColor: "#2C1358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4697,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#351F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4954,
    stopColor: "#422C73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5093,
    stopColor: "#584188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#765FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5303,
    stopColor: "#8770B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5366,
    stopColor: "#7E67AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5617,
    stopColor: "#5C468D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#442E75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#362066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6263,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    stopColor: "#2A1155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7491,
    stopColor: "#230446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.211 42.0543) scale(42.769 42.5733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1614,
    stopColor: "#6C1E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3626,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5849,
    stopColor: "#431233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8208,
    stopColor: "#200918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.053 39.0127) scale(25.197 25.0817)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF8AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2164_1516",
    x1: 108.087,
    y1: 62.3264,
    x2: 38.4876,
    y2: 40.4388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1869,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9343,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2164_1516",
    x1: 108.995,
    y1: 89.1614,
    x2: 73.8865,
    y2: 14.6346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2031,
    stopColor: "#290F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4949,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2164_1516",
    x1: 83.0706,
    y1: 57.9913,
    x2: 105.285,
    y2: 57.9913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2031,
    stopColor: "#290F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4949,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2164_1516",
    x1: 80.5595,
    y1: 32.1438,
    x2: 114.116,
    y2: 96.4231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2164_1516",
    x1: 124.457,
    y1: 41.4402,
    x2: 53.6782,
    y2: 79.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0998,
    stopColor: "#FAC098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4638,
    stopColor: "#A142B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#7926CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6973,
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7764,
    stopColor: "#6165DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    stopColor: "#4C9CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9709,
    stopColor: "#32E1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.824 46.3624) rotate(31.2098) scale(0.774965 0.647962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3889,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4006,
    stopColor: "#E2DEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4226,
    stopColor: "#B0A5BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4447,
    stopColor: "#86749C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#634C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#482D69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    stopColor: "#35175A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5277,
    stopColor: "#290A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5688,
    stopColor: "#1D043C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#120226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6561,
    stopColor: "#0A0115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7138,
    stopColor: "#040109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7934,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.2468 64.422) rotate(31.2098) scale(0.774965 0.647962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3889,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4006,
    stopColor: "#E2DEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4226,
    stopColor: "#B0A5BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4447,
    stopColor: "#86749C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4664,
    stopColor: "#634C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#482D69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    stopColor: "#35175A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5277,
    stopColor: "#290A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5688,
    stopColor: "#1D043C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#120226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6561,
    stopColor: "#0A0115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7138,
    stopColor: "#040109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7934,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2164_1516",
    x1: 101.808,
    y1: 46.7969,
    x2: 84.5621,
    y2: 28.7321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2164_1516",
    x1: 102.154,
    y1: 45.43,
    x2: 79.4831,
    y2: 22.3838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2164_1516",
    x1: 102.927,
    y1: 44.6711,
    x2: 80.2557,
    y2: 21.6248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2164_1516",
    x1: 99.4759,
    y1: 48.4552,
    x2: 76.8053,
    y2: 25.4092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2164_1516",
    x1: 100.249,
    y1: 47.6964,
    x2: 77.5781,
    y2: 24.6502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2164_1516",
    x1: 95.9048,
    y1: 41.2562,
    x2: 97.0807,
    y2: 41.2562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2164_1516",
    x1: 90.6817,
    y1: 35.9306,
    x2: 93.2679,
    y2: 35.9306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2164_1516",
    x1: 93.9144,
    y1: 36.721,
    x2: 97.6704,
    y2: 36.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2164_1516",
    x1: 95.3689,
    y1: 82.5684,
    x2: 97.8372,
    y2: 74.4116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2164_1516",
    x1: 97.425,
    y1: 83.198,
    x2: 100.592,
    y2: 72.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2164_1516",
    x1: 99.6207,
    y1: 84.2082,
    x2: 102.449,
    y2: 74.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2164_1516",
    x1: 90.955,
    y1: 80.6831,
    x2: 94.0018,
    y2: 70.6146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2164_1516",
    x1: 93.3528,
    y1: 81.6774,
    x2: 95.5881,
    y2: 74.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2164_1516",
    x1: 102.146,
    y1: 85.181,
    x2: 105.004,
    y2: 75.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2164_1516",
    x1: 88.456,
    y1: 79.7394,
    x2: 91.6615,
    y2: 69.1463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2164_1516",
    x1: 84.4678,
    y1: 77.7814,
    x2: 86.8413,
    y2: 69.9378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2164_1516",
    x1: 86.0461,
    y1: 78.8332,
    x2: 89.313,
    y2: 68.0376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2164_1516",
    x1: 95.5222,
    y1: 83.3709,
    x2: 99.1052,
    y2: 69.5413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D1CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2929,
    stopColor: "#8A27D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7879,
    stopColor: "#CA3CDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2164_1516",
    x1: 97.7754,
    y1: 84.2276,
    x2: 100.166,
    y2: 74.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D1CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2929,
    stopColor: "#8A27D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7879,
    stopColor: "#CA3CDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2164_1516",
    x1: 99.9476,
    y1: 84.9407,
    x2: 103.009,
    y2: 73.1235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D1CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2929,
    stopColor: "#8A27D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7879,
    stopColor: "#CA3CDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2164_1516",
    x1: 90.9407,
    y1: 82.2154,
    x2: 95.4938,
    y2: 64.6416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D1CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2929,
    stopColor: "#8A27D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7879,
    stopColor: "#CA3CDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2164_1516",
    x1: 93.5063,
    y1: 82.465,
    x2: 95.9692,
    y2: 72.9589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D1CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2929,
    stopColor: "#8A27D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7879,
    stopColor: "#CA3CDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2164_1516",
    x1: 88.2382,
    y1: 81.5161,
    x2: 92.7913,
    y2: 63.9422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D1CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2929,
    stopColor: "#8A27D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7879,
    stopColor: "#CA3CDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2164_1516",
    x1: 84.0545,
    y1: 80.4319,
    x2: 88.6077,
    y2: 62.8578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D1CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2929,
    stopColor: "#8A27D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7879,
    stopColor: "#CA3CDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2164_1516",
    x1: 86.1751,
    y1: 80.9803,
    x2: 90.7282,
    y2: 63.4063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D1CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2929,
    stopColor: "#8A27D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7879,
    stopColor: "#CA3CDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2164_1516",
    x1: 102.521,
    y1: 86.052,
    x2: 105.058,
    y2: 76.2583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D1CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2929,
    stopColor: "#8A27D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7879,
    stopColor: "#CA3CDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2164_1516",
    x1: 118.774,
    y1: 43.8652,
    x2: 30.1499,
    y2: 70.4737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0998,
    stopColor: "#FAC098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4638,
    stopColor: "#A142B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#7926CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6973,
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7764,
    stopColor: "#6165DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    stopColor: "#4C9CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9709,
    stopColor: "#32E1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2164_1516",
    x1: 131.371,
    y1: 40.1413,
    x2: 75.4287,
    y2: 74.8952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0998,
    stopColor: "#FAC098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4638,
    stopColor: "#A142B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#7926CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6973,
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7764,
    stopColor: "#6165DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    stopColor: "#4C9CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9709,
    stopColor: "#32E1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2164_1516",
    x1: 124.196,
    y1: 45.8039,
    x2: 93.525,
    y2: 64.8583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0998,
    stopColor: "#FAC098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4638,
    stopColor: "#A142B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#7926CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6973,
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7764,
    stopColor: "#6165DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    stopColor: "#4C9CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9709,
    stopColor: "#32E1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2164_1516",
    x1: 124.086,
    y1: 44.3208,
    x2: 78.9469,
    y2: 67.2598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0998,
    stopColor: "#FAC098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4638,
    stopColor: "#A142B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#7926CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6973,
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7764,
    stopColor: "#6165DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    stopColor: "#4C9CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9709,
    stopColor: "#32E1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.178 52.1618) scale(3.22148 3.20674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.259 42.0433) scale(7.74485 7.70941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2164_1516",
    x1: 80.5129,
    y1: -30.8345,
    x2: 1.73378,
    y2: 86.3746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2164_1516",
    x1: 80.5129,
    y1: -5.64289,
    x2: 1.73377,
    y2: 111.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2164_1516",
    x1: 32.9925,
    y1: 13.3875,
    x2: 10.2785,
    y2: 56.8979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2164_1516",
    x1: 33.1137,
    y1: 13.4781,
    x2: 10.4448,
    y2: 56.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2164_1516",
    x1: 33.2455,
    y1: 13.5683,
    x2: 10.6218,
    y2: 56.9057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2164_1516",
    x1: 33.3684,
    y1: 13.6586,
    x2: 10.7899,
    y2: 56.9097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2164_1516",
    x1: 33.4886,
    y1: 13.7484,
    x2: 10.9552,
    y2: 56.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2164_1516",
    x1: 33.6189,
    y1: 13.8381,
    x2: 11.1306,
    y2: 56.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2164_1516",
    x1: 33.7386,
    y1: 13.9273,
    x2: 11.295,
    y2: 56.9198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2164_1516",
    x1: 33.8678,
    y1: 14.0165,
    x2: 11.4689,
    y2: 56.9229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2164_1516",
    x1: 33.9888,
    y1: 14.1055,
    x2: 11.6351,
    y2: 56.9259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2164_1516",
    x1: 34.1148,
    y1: 14.1939,
    x2: 11.8058,
    y2: 56.9284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2164_1516",
    x1: 34.2348,
    y1: 14.2822,
    x2: 11.9709,
    y2: 56.9309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2164_1516",
    x1: -6.21273,
    y1: 70.4777,
    x2: 85.6962,
    y2: -9.56174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5529,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2164_1516",
    x1: -5.7665,
    y1: 70.6752,
    x2: 86.1425,
    y2: -9.36419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5529,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2164_1516",
    x1: 4.97879,
    y1: 65.8994,
    x2: 48.7467,
    y2: 6.24049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2164_1516",
    x1: 12.9317,
    y1: 60.6833,
    x2: 56.6996,
    y2: 1.0245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2164_1516",
    x1: 15.848,
    y1: 73.8772,
    x2: 59.616,
    y2: 14.2184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2164_1516",
    x1: 7.85026,
    y1: 68.0099,
    x2: 51.6181,
    y2: 8.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2164_1516",
    x1: 18.6141,
    y1: 75.9037,
    x2: 62.382,
    y2: 16.2449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2164_1516",
    x1: -14.1452,
    y1: 68.5741,
    x2: 81.6397,
    y2: -14.8408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5529,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2164_1516",
    x1: -12.4208,
    y1: 72.6917,
    x2: 83.3641,
    y2: -10.7231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5529,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2164_1516",
    x1: -10.6965,
    y1: 76.8097,
    x2: 85.0884,
    y2: -6.60513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5529,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2164_1516",
    x1: -8.97217,
    y1: 80.9274,
    x2: 86.8128,
    y2: -2.48751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5529,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2164_1516",
    x1: -7.24834,
    y1: 85.0451,
    x2: 88.5366,
    y2: 1.6304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5529,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2164_1516",
    x1: 0.0332909,
    y1: 70.4567,
    x2: 85.2583,
    y2: -3.76295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5529,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2164_1516",
    x1: -1.74186,
    y1: 69.8244,
    x2: 83.4836,
    y2: -4.39489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5529,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2164_1516",
    x1: -3.50996,
    y1: 69.1922,
    x2: 81.7155,
    y2: -5.02679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5529,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2164_1516",
    x1: -5.28536,
    y1: 68.5599,
    x2: 79.9396,
    y2: -5.65903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#A580CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#B492D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5529,
    stopColor: "#CDB0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#DBC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2164_1516",
    x1: 9.05274,
    y1: 31.5316,
    x2: 16.3752,
    y2: 24.4801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2164_1516",
    x1: 15.1392,
    y1: 28.0267,
    x2: 22.4616,
    y2: 20.9751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2164_1516",
    x1: 21.2257,
    y1: 24.5218,
    x2: 28.5481,
    y2: 17.4702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2164_1516",
    x1: 27.3121,
    y1: 21.0168,
    x2: 34.634,
    y2: 13.9652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2164_1516",
    x1: 33.3986,
    y1: 17.5119,
    x2: 40.7205,
    y2: 10.4602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2164_1516",
    x1: 39.4846,
    y1: 14.007,
    x2: 46.8069,
    y2: 6.95532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D1D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6898 28.6198) rotate(179.795) scale(3.11765 3.10338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.66893 29.0036) rotate(179.795) scale(1.72238 1.7145)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8308 25.1181) rotate(179.795) scale(3.11765 3.10338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8021 25.5021) rotate(179.795) scale(1.72238 1.7145)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.8689 21.6169) rotate(179.795) scale(3.11765 3.10338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8403 22.001) rotate(179.795) scale(1.72243 1.71455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9762 18.0833) rotate(179.795) scale(3.11765 3.10338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.9481 18.4673) rotate(179.795) scale(1.72243 1.71455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.1094 14.5818) rotate(179.795) scale(3.11764 3.10338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0886 14.9658) rotate(179.795) scale(1.72243 1.71455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1554 11.0807) rotate(179.795) scale(3.11764 3.10338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.7047 25.2083) rotate(-122.857) scale(2.38173 2.18885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BD7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#8B554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#603B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#3E2622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#231513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#0F0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#040202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2164_1516",
    x1: 20.8063,
    y1: 68.1221,
    x2: 51.8505,
    y2: 24.1598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2164_1516",
    x1: 23.6521,
    y1: 70.1325,
    x2: 54.6964,
    y2: 26.1703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2164_1516",
    x1: 12.9036,
    y1: 62.5415,
    x2: 43.9478,
    y2: 18.5791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2164_1516",
    x1: 17.5385,
    y1: 54.7664,
    x2: 48.5828,
    y2: 10.8041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2164_1516",
    x1: 9.63573,
    y1: 60.2367,
    x2: 40.6801,
    y2: 16.2744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2164_1516",
    x1: 32.2139,
    y1: 48.6249,
    x2: 22.5151,
    y2: 67.2044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2164_1516",
    x1: 32.2728,
    y1: 48.6636,
    x2: 22.5931,
    y2: 67.2061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2164_1516",
    x1: 32.3215,
    y1: 48.7023,
    x2: 22.6609,
    y2: 67.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2164_1516",
    x1: 32.3771,
    y1: 48.7408,
    x2: 22.7357,
    y2: 67.2096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2164_1516",
    x1: 32.4303,
    y1: 48.7791,
    x2: 22.8081,
    y2: 67.2111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2164_1516",
    x1: 32.4886,
    y1: 48.8174,
    x2: 22.8856,
    y2: 67.2125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2164_1516",
    x1: 32.5386,
    y1: 48.8555,
    x2: 22.9552,
    y2: 67.2138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2164_1516",
    x1: 32.5942,
    y1: 48.8936,
    x2: 23.0299,
    y2: 67.2152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2164_1516",
    x1: 32.6442,
    y1: 48.9315,
    x2: 23.0985,
    y2: 67.2164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2164_1516",
    x1: 32.6937,
    y1: 48.9695,
    x2: 23.1672,
    y2: 67.2177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2164_1516",
    x1: 32.7506,
    y1: 49.0071,
    x2: 23.2437,
    y2: 67.2187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2164_1516",
    x1: 24.8774,
    y1: 61.8295,
    x2: 15.1781,
    y2: 80.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2164_1516",
    x1: 24.9362,
    y1: 61.8681,
    x2: 15.2561,
    y2: 80.4107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2164_1516",
    x1: 24.9895,
    y1: 61.9066,
    x2: 15.329,
    y2: 80.4123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2164_1516",
    x1: 25.0405,
    y1: 61.9453,
    x2: 15.3991,
    y2: 80.4141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2164_1516",
    x1: 25.0937,
    y1: 61.9835,
    x2: 15.4715,
    y2: 80.4154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2164_1516",
    x1: 25.1516,
    y1: 62.022,
    x2: 15.549,
    y2: 80.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2164_1516",
    x1: 25.2021,
    y1: 62.0601,
    x2: 15.6181,
    y2: 80.4184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2164_1516",
    x1: 25.2544,
    y1: 62.0981,
    x2: 15.6901,
    y2: 80.4197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2164_1516",
    x1: 25.3071,
    y1: 62.136,
    x2: 15.762,
    y2: 80.4209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2164_1516",
    x1: 25.3566,
    y1: 62.1738,
    x2: 15.8307,
    y2: 80.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2164_1516",
    x1: 25.414,
    y1: 62.2115,
    x2: 15.9066,
    y2: 80.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2164_1516",
    x1: 26.579,
    y1: 51.2073,
    x2: 26.579,
    y2: 100.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6076,
    stopColor: "#F5F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#D8D8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#ABAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9202,
    stopColor: "#6C6C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2164_1516",
    x1: 30.1045,
    y1: 52.3888,
    x2: 25.8713,
    y2: 59.7548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2164_1516",
    x1: 27.484,
    y1: 79.0204,
    x2: 64.8441,
    y2: 76.1422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2164_1516",
    x1: 13.0057,
    y1: 76.8833,
    x2: 35.5553,
    y2: 80.6786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2164_1516",
    x1: 28.3104,
    y1: 100.846,
    x2: 52.5679,
    y2: 98.9776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2164_1516",
    x1: 19.1324,
    y1: 99.7942,
    x2: 29.9097,
    y2: 101.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0409 67.861) scale(15.6977 15.6259)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2164_1516",
    x1: 19.2636,
    y1: 64.9974,
    x2: 19.2636,
    y2: 104.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6076,
    stopColor: "#F5F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#D8D8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#ABAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9202,
    stopColor: "#6C6C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2164_1516",
    x1: 22.7891,
    y1: 65.6108,
    x2: 18.5557,
    y2: 72.9769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2164_1516",
    x1: 20.3709,
    y1: 87.6434,
    x2: 54.6014,
    y2: 85.0063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2164_1516",
    x1: 7.15365,
    y1: 85.7654,
    x2: 26.8913,
    y2: 89.0874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2164_1516",
    x1: 21.0012,
    y1: 104.554,
    x2: 45.2419,
    y2: 102.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2164_1516",
    x1: 11.8247,
    y1: 103.504,
    x2: 22.587,
    y2: 105.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7254 78.8291) scale(12.6485 12.5906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2164_1516",
    x1: 11.7788,
    y1: 68.9264,
    x2: 11.7788,
    y2: 108.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6076,
    stopColor: "#F5F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#D8D8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#ABAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9202,
    stopColor: "#6C6C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2164_1516",
    x1: 15.3044,
    y1: 78.5505,
    x2: 11.0711,
    y2: 85.9165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2164_1516",
    x1: 13.0802,
    y1: 96.0628,
    x2: 44.2348,
    y2: 93.6627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2164_1516",
    x1: 1.10727,
    y1: 94.4395,
    x2: 18.0813,
    y2: 97.2964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2164_1516",
    x1: 13.5162,
    y1: 108.446,
    x2: 37.7601,
    y2: 106.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2164_1516",
    x1: 4.33857,
    y1: 107.395,
    x2: 15.1035,
    y2: 109.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.24082 89.5534) scale(9.7484 9.7038)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2164_1516",
    x1: 4.38942,
    y1: 73.5154,
    x2: 4.38942,
    y2: 113.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6076,
    stopColor: "#F5F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#D8D8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#ABAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9202,
    stopColor: "#6C6C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2164_1516",
    x1: 7.91499,
    y1: 91.9691,
    x2: 3.68165,
    y2: 99.3351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2164_1516",
    x1: 7.91499,
    y1: 105.116,
    x2: 3.68166,
    y2: 112.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2164_1516",
    x1: 5.87596,
    y1: 105.052,
    x2: 34.0164,
    y2: 102.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2164_1516",
    x1: -4.87271,
    y1: 103.678,
    x2: 9.39304,
    y2: 106.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2164_1516",
    x1: 6.1262,
    y1: 112.832,
    x2: 30.2991,
    y2: 110.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2164_1516",
    x1: -3.01762,
    y1: 111.787,
    x2: 7.68362,
    y2: 113.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3BFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_2164_1516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.851413 100.801) scale(7.11421 7.08166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2164_1516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 115,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.0448c72ca318a6a4a58f5ba14d60e0db.svg";
export { ForwardRef as ReactComponent };